<template>
    <div>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <v-form
                ref="contactForm"
                @submit.prevent="handleSubmit(handleSubmission)"
            >
                <input
                    id="form-name"
                    type="hidden"
                    name="form-name"
                    value="checkoutForm"
                />
                <v-container class>
                    <v-row>
                        <v-col cols="12">
                            <v-container class="pr-0 pl-0">
                                <v-row>
                                    <!-- FIRST NAME -->
                                    <v-col cols="12" sm="6" class="pb-0">
                                        <CustomInputField
                                            v-model="nameFirst"
                                            name="billingFirstName"
                                            rules="required"
                                            :readonly="iseditable"
                                            :hint="hints.billingFirstName"
                                            :label="localize('firstName')"
                                        />
                                    </v-col>
                                    <!-- LAST NAME -->
                                    <v-col cols="12" sm="6" class="pb-0">
                                        <CustomInputField
                                            v-model="nameLast"
                                            name="billingLastName"
                                            rules="required"
                                            :readonly="iseditable"
                                            :hint="hints.billingLastName"
                                            :label="localize('lastName')"
                                        />
                                    </v-col>
                                    <!-- COMPANY -->
                                    <v-col cols="12" class="pb-0 pt-0">
                                        <v-checkbox
                                            v-if="!iseditable"
                                            v-model="companyEnabled"
                                            :readonly="iseditable"
                                            hide-details
                                            class="shrink mr-2 mt-0 mb-1"
                                            :label="
                                                localize(
                                                    'thisIsACompanyAddress'
                                                )
                                            "
                                        ></v-checkbox>
                                        <CustomInputField
                                            v-model="nameCompany"
                                            :disabled="!companyEnabled"
                                            :readonly="iseditable"
                                            name="billingCompany"
                                            :rules="
                                                companyEnabled && !iseditable
                                                    ? 'required|companyName'
                                                    : ''
                                            "
                                            :hint="hints.billingCompany"
                                            :label="localize('company')"
                                        />
                                    </v-col>
                                    <v-col cols="12" class="pb-0 pt-0">
                                        <ValidationProvider
                                            name="taxable"
                                            rules="required"
                                            class="validationWrapper"
                                        >
                                            <div
                                                slot-scope="{ errors }"
                                                class="d-flex"
                                            >
                                                <span
                                                    class="validationMessage"
                                                    >{{ errors[0] }}</span
                                                >

                                                <v-radio-group
                                                    v-if="companyEnabled"
                                                    v-model="taxable"
                                                    :disabled="
                                                        !isCustomerTaxable
                                                    "
                                                    hide-details
                                                    class="mt-0 pt-0"
                                                    row
                                                >
                                                    <template v-slot:label>
                                                        <div>
                                                            {{
                                                                localize(
                                                                    'taxable'
                                                                )
                                                            }}?
                                                        </div>
                                                    </template>
                                                    <v-radio
                                                        :label="localize('yes')"
                                                        :value="true"
                                                    ></v-radio>
                                                    <v-radio
                                                        :label="localize('no')"
                                                        :value="false"
                                                    ></v-radio>
                                                </v-radio-group>
                                                <span
                                                    v-if="!isCustomerTaxable"
                                                    class="text--disabled font-italic font-weight-light caption"
                                                    >(Your company is tax
                                                    exempt)</span
                                                >
                                            </div>
                                        </ValidationProvider>
                                    </v-col>
                                    <!-- BILLING COUNTRY -->
                                    <v-col cols="12" class="pb-0">
                                        <ValidationProvider
                                            name="billingCountry"
                                            rules="required"
                                            class="validationWrapper"
                                        >
                                            <div slot-scope="{ errors }">
                                                <span
                                                    class="validationMessage"
                                                    >{{ errors[0] }}</span
                                                >
                                                <v-select
                                                    id="billingCountry"
                                                    v-model="
                                                        addressCountryLocal
                                                    "
                                                    :items="countries"
                                                    name="billingCountry"
                                                    :readonly="iseditable"
                                                    item-text="name"
                                                    item-value="name"
                                                    :label="
                                                        iseditable
                                                            ? `${localize(
                                                                  'country'
                                                              )} (to change country please add a new address)`
                                                            : localize(
                                                                  'country'
                                                              )
                                                    "
                                                    outlined
                                                    dense
                                                    @change="updatePhoneCode()"
                                                >
                                                    <!-- <option disabled value=""
                                                                >Please select one</option
                                                    >-->
                                                    <template
                                                        slot="selection"
                                                        slot-scope="data"
                                                    >
                                                        <!-- HTML CAN WRAP THIS -->
                                                        {{ data.item.name }}
                                                    </template>
                                                    <template
                                                        slot="item"
                                                        slot-scope="data"
                                                    >
                                                        <!-- HTML CAN WRAP THIS -->
                                                        {{ data.item.name }}
                                                    </template>
                                                </v-select>
                                            </div>
                                        </ValidationProvider>
                                    </v-col>
                                    <!-- STREET ADDRESS 1 -->
                                    <v-col cols="12" class="pb-0">
                                        <CustomInputField
                                            v-model="address1"
                                            name="billingAddress1"
                                            rules="required"
                                            :hint="hints.billingAddress1"
                                            :label="localize('address1')"
                                        />
                                    </v-col>
                                    <!-- STREET ADDRESS 2 -->
                                    <v-col cols="12" class="pb-0">
                                        <CustomInputField
                                            v-model="address2"
                                            name="billingAddress2"
                                            :hint="hints.billingAddress2"
                                            :label="localize('address2')"
                                        />
                                    </v-col>
                                    <!-- CITY -->
                                    <v-col cols="8" class="pb-0">
                                        <CustomInputField
                                            v-model="addressCity"
                                            name="billingCity"
                                            :hint="hints.billingCity"
                                            :label="localize('cityTown')"
                                        />
                                    </v-col>
                                    <!-- STATE -->
                                    <v-col cols="4" class="pb-0">
                                        <ValidationProvider
                                            name="billingState"
                                            rules="required"
                                            class="validationWrapper"
                                        >
                                            <div slot-scope="{ errors }">
                                                <span class="validationMessage">
                                                    {{ errors[0] }}
                                                </span>

                                                <v-select
                                                    v-show="
                                                        addressCountry ===
                                                            'United States' ||
                                                        addressCountry ===
                                                            'Canada'
                                                    "
                                                    id="billingState"
                                                    v-model="addressState"
                                                    :items="
                                                        addressCountry ===
                                                        'United States'
                                                            ? statesUS
                                                            : provincesCanada
                                                    "
                                                    name="billingState"
                                                    item-text="name"
                                                    item-value="alpha2code"
                                                    :label="
                                                        localize(
                                                            'stateProvince'
                                                        )
                                                    "
                                                    outlined
                                                    dense
                                                    :hide-details="true"
                                                >
                                                    <!-- <option disabled value=""
                                                                >Please select one</option
                                                    >-->
                                                    <template
                                                        slot="selection"
                                                        slot-scope="data"
                                                    >
                                                        <!-- HTML CAN WRAP THIS -->
                                                        {{ data.item.name }}
                                                    </template>
                                                    <template
                                                        slot="item"
                                                        slot-scope="data"
                                                    >
                                                        <!-- HTML CAN WRAP THIS -->
                                                        {{ data.item.name }}
                                                    </template>
                                                </v-select>
                                                <v-text-field
                                                    v-show="
                                                        addressCountry !==
                                                            'United States' &&
                                                        addressCountry !==
                                                            'Canada'
                                                    "
                                                    id="billingState"
                                                    v-model="addressState"
                                                    name="billingState"
                                                    :label="
                                                        localize(
                                                            'stateProvince'
                                                        )
                                                    "
                                                    outlined
                                                    dense
                                                    :hide-details="true"
                                                ></v-text-field>
                                            </div>
                                        </ValidationProvider>
                                    </v-col>
                                    <!-- ZIP CODE -->
                                    <!-- Consider https://www.zipcodeapi.com/Plans -->
                                    <v-col cols="12" class="pb-0">
                                        <CustomInputField
                                            v-model="addressPostalCode"
                                            name="billingZip"
                                            :rules="zipcodeValidationRule"
                                            :hint="hints.billingZip"
                                            :label="localize('zipPostalCode')"
                                        />
                                    </v-col>
                                    <!-- PHONE NUMBER -->
                                    <v-col cols="3" class="pb-0">
                                        <v-select
                                            id="countryCode"
                                            v-model="phone1CCLocal"
                                            :items="countries"
                                            name="countryCode"
                                            item-text="phoneCode"
                                            item-value="phoneCode"
                                            :label="localize('countryCode')"
                                            outlined
                                            dense
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="6" class="pb-0">
                                        <CustomInputField
                                            v-model="phone1"
                                            name="billingPhone"
                                            rules="required"
                                            :hint="hints.billingPhone"
                                            :mask="
                                                phone1CC === '1'
                                                    ? phoneMask
                                                    : '###############'
                                            "
                                            :label="localize('phone')"
                                        />
                                    </v-col>
                                    <v-col cols="3" class="pb-0">
                                        <CustomInputField
                                            v-model="phone1Ext"
                                            name="phoneExt"
                                            rules=""
                                            :hint="hints.billingEmail"
                                            :label="localize('ext')"
                                        />
                                    </v-col>
                                    <!-- EMAIL ADDRESS -->
                                    <v-col cols="12" class="pb-0">
                                        <CustomInputField
                                            v-model="email1"
                                            name="billingEmail"
                                            rules="required"
                                            :hint="hints.billingEmail"
                                            :label="
                                                localize('contactEmailAddress')
                                            "
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                    <v-row v-if="iscontactcard">
                        <v-col cols="12">
                            <v-btn
                                color="success"
                                right
                                type="submit"
                                @click="scrollIntoView()"
                            >
                                <TranslatableStringComponent
                                    :tstring="{ string: 'save' }"
                                />
                            </v-btn>
                            <v-btn
                                color="success"
                                outlined
                                right
                                @click="closeDialogForm()"
                            >
                                <TranslatableStringComponent
                                    :tstring="{ string: 'close' }"
                                />
                            </v-btn>
                            <v-btn
                                v-if="!iseditable"
                                v-scroll-to="{
                                    el: '#customerDetailsChips',
                                    offset: -40,
                                }"
                                color="primary"
                                dense
                                outlined
                                left
                                @click="resetForm()"
                            >
                                <TranslatableStringComponent
                                    :tstring="{ string: 'reset' }"
                                />
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                        <v-col cols="12" class="text-right">
                            <v-btn color="primary" dense right type="submit">
                                <TranslatableStringComponent
                                    :tstring="{ string: 'proceedToPayment' }"
                                />
                                &rarr;</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </ValidationObserver>
        <v-overlay :value="overlay" opacity="0">
            <v-progress-circular
                :size="80"
                :width="3"
                color="#0063a6"
                indeterminate
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { createHelpers } from 'vuex-map-fields'
import { mapState, mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'
import CustomInputField from '~/components/CustomInputField'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import countries from '~/util/arrays/countries.js'
import statesUS from '~/util/statesUS.js'
import provincesCanada from '~/util/arrays/provincesCanada.js'
import encodeFormData from '~/mixins/encodeFormData'
import scrollIntoView from '~/mixins/scrollIntoView'
import fetchTaxableNexusObj from '~/util/fetchTaxableNexusObj'
import handleSnackbar from '~/mixins/handleSnackbar'

const { mapFields } = createHelpers({
    getterType: 'getContactCardField',
    mutationType: 'updateContactCardField',
})

export default {
    name: 'FormContactCard',
    components: {
        ValidationProvider,
        ValidationObserver,
        CustomInputField,
        TranslatableStringComponent,
    },
    directives: {
        mask,
    },
    mixins: [encodeFormData, scrollIntoView, handleSnackbar],
    props: {
        defaultemailid: {
            type: String,
            default: '',
        },
        iseditable: {
            type: Boolean,
        },
        iscontactcard: {
            type: Boolean,
        },
        cardobj: {
            type: Object,
            default: () => ({
                nameFirst: '',
                nameLast: '',
                nameCompany: '',
                addressCountry: 'United States',
                address1: '',
                address2: '',
                addressCity: '',
                addressState: '',
                addressPostalCode: '',
                phone1: '',
                email1: '',
                name: '',
                taxable: null,
                id: null,
            }),
        },
        resetContactForm: {
            type: String,
        },
    },
    data() {
        return {
            cart: [],
            countries,
            statesUS,
            provincesCanada,
            isCart: false,
            isCheckout: true,
            dialog: false,
            overlay: false,
            addressCountryLocal: {
                name: 'United States',
                phoneCode: '+1',
                alpha2code: 'US',
                alpha3code: 'USA',
            },
            phone1CCLocal: {
                name: 'United States',
                phoneCode: '+1',
                alpha2code: 'US',
                alpha3code: 'USA',
            },
            phoneMask: '(###) ###-####',
            UsZipCodeRegex: '^[0-9]{5}(?:-[0-9]{4})?$',
            companyEnabled: true,
            hints: {
                billingFirstName: this.localize('cardholderSFirstName'),
                billingLastName: this.localize('cardholderSLastName'),
                billingCompany: '',
                billingCountry: '',
                billingAddress1: this.localize(
                    'billingAddressNumberAndStreetName'
                ),
                billingAddress2: '',
                billingCity: '',
                billingState: '',
                billingZip: '',
                billingPhone: '',
                billingEmail: '',
                shippingFirstName: this.localize('recipientSFirstName'),
                shippingLastName: this.localize('recipientSLastName'),
                shippingCompany: '',
                shippingCountry: 'US',
                shippingAddress1: this.localize(
                    'shippingAddressNumberAndStreetName'
                ),
                shippingAddress2: '',
                shippingCity: '',
                shippingState: '',
                shippingZip: '',
                shippingPhone: '',
                shippingEmail: '',
                purchaseOrder: '',
                shippingAccount: 'FedEx or UPS Account #',
                orderMessage:
                    'Notes about your order, e.g. delivery instructions',
            },
        }
    },
    computed: {
        ...mapState('common', ['siteSettings']),
        ...mapState('auth', ['webUser']),
        ...mapGetters({
            subtotal: 'cart/fetchCartSubtotal',
            cartProducts: 'cart/fetchCartProducts',
            isCustomerTaxable: 'auth/isCustomerTaxable',
        }),
        ...mapFields('contactCard', [
            'nameFirst',
            'nameLast',
            'nameCompany',
            'addressCountry',
            'address1',
            'address2',
            'addressCity',
            'addressState',
            'addressPostalCode',
            'phone1',
            'email1',
            'taxable',
            'phone1CC',
            'phone1Ext',
        ]),
        isCountrySelectedUS() {
            return (
                this.$store.state.contactCard.contactCard.addressCountry ===
                'United States'
            )
        },
        zipcodeValidationRule() {
            return this.isCountrySelectedUS ? 'required|digits:5' : 'required'
        },
        fetchNexusTaxObj() {
            let { addressCountry } = this.$store.state.contactCard.contactCard
            if (addressCountry === 'United States') {
                return fetchTaxableNexusObj({
                    taxRates: this.siteSettings?.taxRates,
                    contactDetails: this.$store.state.contactCard.contactCard,
                })
            } else {
                return {
                    taxGroupName: 'INX',
                }
            }
        },
        taxGroupRelation() {
            const taxGroupName = this.fetchNexusTaxObj?.taxGroupName
            return taxGroupName
                ? {
                      connect: {
                          name: taxGroupName,
                      },
                  }
                : undefined
        },
    },
    watch: {
        cardobj() {
            this.setCurrenEditableForm(this.cardobj)
        },
        companyEnabled(val) {
            if (!val) {
                this.$store.commit('contactCard/setCompanyName', '')
            }
        },
        addressCountryLocal(val) {
            if (typeof val === 'string')
                this.$store.commit('contactCard/resetCountry', val)
            else {
                this.$store.commit('contactCard/resetCountry', val?.name)
            }
            this.updatePhoneCode()
        },
        phone1CCLocal(val) {
            if (typeof val === 'string')
                this.$store.commit('contactCard/resetPhoneCode', val.replace('+',''))
            else {
                this.$store.commit('contactCard/resetPhoneCode', val?.phoneCode.replace('+',''))
            }
        },
    },
    mounted() {
        if (this.iseditable === true) {
            // console.log('is editable!')
            this.setCurrenEditableForm(this.cardobj)
        }
        if (this.resetContactForm === 'yes') this.resetForm()
        this.$store.commit('contactCard/resetTaxable', this.isCustomerTaxable)
    },
    methods: {
        handleSubmission() {
            if (!this.iscontactcard) {
                this.$store.commit(
                    'customerDetails/setNewPrimaryContact',
                    this.$store.state.contactCard.contactCard
                )
                this.routerPush({ type: 'page', slugName: 'payment' })
            } else if (this.iseditable === true) {
                this.overlay = true
                this.editExistingContact()
            } else {
                this.overlay = true
                this.addNewContact()
            }
        },
        async addNewContact() {
            let contactName, printAsName
            let {
                nameCompany,
                addressCity,
                nameFirst,
                nameLast,
            } = this.$store.state.contactCard.contactCard
            if (nameCompany) {
                // console.log('company name is present')
                contactName = `${nameCompany} - ${addressCity} (W${Math.floor(
                    Date.now() / 1000
                )})`
                printAsName = nameCompany
            } else {
                // console.log('company not present')
                contactName = `${nameFirst} ${nameLast} - ${addressCity} (W${Math.floor(
                    Date.now() / 1000
                )})`
                printAsName = `${nameFirst} ${nameLast}`
            }

            try {
                const res = await this.$axios.post(
                    'erp-contact?method=create',
                    {
                        ...this.$store.state.contactCard.contactCard,
                        name: contactName,
                        namePrintAs: printAsName,
                        WebUser: {
                            connect: {
                                id: this.webUser.id,
                            },
                        },
                        TaxGroup: this.taxGroupRelation,
                    }
                )
                if (res.data?.createContact) {
                    const payload = {
                        ...this.$store.state.contactCard.contactCard,
                        name: res.data.createContact.name,
                        id: res.data.createContact.id,
                    }
                    this.hitSnackbar({ string: 'newContactCreated' }, null)
                    this.$store.dispatch('checkout/addNewContact', payload)
                    await this.resetForm()
                    this.$emit('setCurrentActiveTabIndex', null)
                } else {
                    throw new Error()
                }
            } catch (error) {
                this.hitSnackbar(
                    { string: 'contactCreateEditErrorMessage' },
                    null
                )
                console.log(error)
            }
            this.overlay = false
        },
        async editExistingContact() {
            try {
                const res = await this.$axios.post(
                    'erp-contact?method=update',
                    {
                        ...this.$store.state.contactCard.contactCard,
                        name: this.cardobj.name,
                        id: this.cardobj.id,
                        TaxGroup: this.taxGroupRelation,
                    }
                )
                if (res.data?.updateContact) {
                    const payload = {
                        ...this.$store.state.contactCard.contactCard,
                        id: res.data.updateContact.id,
                    }
                    this.hitSnackbar({ string: 'contactUpdated' }, null)
                    this.$store.dispatch(
                        'checkout/editExistingContact',
                        payload
                    )
                    await this.resetForm()
                    this.$emit('setCurrentActiveTabIndex', null)
                } else {
                    throw new Error()
                }
            } catch (error) {
                this.hitSnackbar(
                    { string: 'contactCreateEditErrorMessage' },
                    null
                )
                console.log(error)
            }
            this.overlay = false
        },
        resetForm() {
            if (this.$refs) {
                if (this.$refs.contactForm) {
                    this.$refs.contactForm.reset()
                }
                if (!this.iscontactcard) {
                    this.$store.commit(
                        'customerDetails/setPrimaryContactIdForCustomer',
                        null
                    )
                }
                this.companyEnabled = true
                this.$store.commit(
                    'contactCard/resetTaxable',
                    this.isCustomerTaxable
                )
                this.addressCountryLocal = {
                    name: 'United States',
                    phoneCode: '+1',
                    alpha2code: 'US',
                    alpha3code: 'USA',
                }
                this.updatePhoneCode()
                requestAnimationFrame(() => {
                    if (
                        this.$refs.observer &&
                        this.$refs.observer !== undefined
                    ) {
                        this.$refs.observer.reset()
                    }
                })
            }
        },
        setCurrenEditableForm(cardobj) {
            this.$store.commit('contactCard/setContactCard', cardobj)
        },
        clearFields() {
            this.$store.commit('contactCard/clearFields')
        },
        updatePhoneCode() {
            this.clearFields()
            let { addressCountry } = this.$store.state.contactCard.contactCard
            this.phone1CCLocal = this.countries.find(
                (i) => i.name === addressCountry
            )
        },
        closeDialogForm() {
            this.$emit('setCurrentActiveTabIndex', null)
        },
    },
}
</script>
